import {
  GetCompanyDetailDocument,
  GetCompanyDetailQuery,
  ToggleFavoriteMutation,
  useGetCompanyDetailQuery,
  useToggleFavoriteMutation
} from 'generated/graphql';
import update from 'immutability-helper';
import { gqlCacheUtil } from 'modules/common';
import {
  useCallback,
  useMemo
} from 'react';



export interface IData {
  ticker: string;
  companyName: string;
  isFavorite: boolean;
  filingUrl: string;
  websiteUrl: string;
}

export function useQuery(listedCompanyId: string) {
  const tuple = useGetCompanyDetailQuery({
    skip: !listedCompanyId,
    variables: {
      id: listedCompanyId
    }

  });

  return useMemo(
    () => {
      const data: IData = {
        ticker: tuple.data?.listedCompany?.ticker ?? '-',
        companyName: tuple.data?.listedCompany?.companyName ?? '-',
        filingUrl: tuple.data?.listedCompany?.filingUrl ?? '-',
        isFavorite: tuple.data?.listedCompany?.isFavorite ?? false,
        websiteUrl: tuple.data?.listedCompany?.websiteUrl ?? '-'
      };
      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useToggleFavorite(listedCompanyId: string) {
  const [
    fnMutate,
    tuple
  ] = useToggleFavoriteMutation({
  });

  const fnWrappedMutate = useCallback(
    async (isFavorite: boolean) => {
      await fnMutate({
        updateQueries: gqlCacheUtil.genUpdateQueryMap<
          GetCompanyDetailQuery,
          ToggleFavoriteMutation
        >(GetCompanyDetailDocument, (prev, { mutationResult }) => {
          return update(prev, {
            listedCompany: {
              isFavorite: {
                $set: mutationResult.data?.toggleFavorite?.isFavorite ?? isFavorite
              }
            }
          });
        }),
        variables: {
          input: {
            isFavorite,
            listedCompanyId
          }
        }
      });
    },
    [
      fnMutate,
      listedCompanyId
    ]
  );

  return useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
